// Pure item lifecycle (REQ-ITEM-003): draft → open → done, and → cancelled from any
// non-done state. No transition out of `done`. Unit-tested; the UI wires the actions.
export type ItemStatus = "draft" | "open" | "done" | "cancelled";
export type ItemAction = "commit" | "done" | "cancel";

export function nextStatus(current: ItemStatus, action: ItemAction): ItemStatus {
  switch (action) {
    case "commit":
      return current === "draft" ? "open" : current;
    case "done":
      if (current === "done" || current === "cancelled") throw new Error(`cannot mark done from ${current}`);
      return "done";
    case "cancel":
      if (current === "done") throw new Error("cannot cancel a done item");
      return "cancelled";
  }
}
